export const IMAGES = {
  portrait:
    "https://static.prod-images.emergentagent.com/jobs/7df89ba4-2e95-4b11-bc51-9873287ee9e6/images/5e5689c7a57312f237d208b6ffc4d247d77b55202b63a282725dc3d439dafe92.jpeg",
  about:
    "https://static.prod-images.emergentagent.com/jobs/7df89ba4-2e95-4b11-bc51-9873287ee9e6/images/4f7e2a7c07e58010969d06885af380776ec65ff59c9710e4213e97260d3d5d9e.jpeg",
  candid:
    "https://static.prod-images.emergentagent.com/jobs/7df89ba4-2e95-4b11-bc51-9873287ee9e6/images/ce48b4aa05d71873b011e74f310e8ee8e93ad10c1f3106dd5528b8d3a9117dd7.jpeg",
  portraitAlt:
    "https://static.prod-images.emergentagent.com/jobs/7df89ba4-2e95-4b11-bc51-9873287ee9e6/images/ccdefccaff654967900700ce61f59de88b04e2c2b94affded45db72a12ff91d2.jpeg",
  leaders:
    "https://static.prod-images.emergentagent.com/jobs/7df89ba4-2e95-4b11-bc51-9873287ee9e6/images/df1afd831984bb29eaaa45340107997e2145a0642c5421cc92c0c7a4af250fa3.jpeg",
  worship:
    "https://static.prod-images.emergentagent.com/jobs/7df89ba4-2e95-4b11-bc51-9873287ee9e6/images/a2defe0fc322e5164da61e4d0c26ea34d7014768658f77a3d6005e16bc507583.jpeg",
  mentor:
    "https://static.prod-images.emergentagent.com/jobs/7df89ba4-2e95-4b11-bc51-9873287ee9e6/images/5865741516ba03c4e9876b619988f439ee6922ff5d39f7eb46d1e3be8aa5055f.jpeg",
  volunteers:
    "https://static.prod-images.emergentagent.com/jobs/7df89ba4-2e95-4b11-bc51-9873287ee9e6/images/faa36a08354e1f8c9590b069cdcb334ccd7d54a6e6097e959f2144ad77ac6a16.jpeg",
  video:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_mckuhn-official/artifacts/9178fa1464136063_0198b9775f5d73cc2142ff431ea9faa5.mp4",
  lion:
    "https://static.prod-images.emergentagent.com/jobs/7df89ba4-2e95-4b11-bc51-9873287ee9e6/images/ca9f6cbe640829db036688f671da3eb4ad6e9cf71751e693668f98b01a6ae4c9.jpeg",
  heroPrayerVideo:
    `${process.env.REACT_APP_BACKEND_URL}/api/files/mckuhn/uploads/8c06193c-007a-4e7a-afa7-0e0869d8cfa6.mp4`,
  heroPrayerVideoWebm:
    `${process.env.REACT_APP_BACKEND_URL}/api/files/mckuhn/uploads/5ee2fffa-98d2-4299-bb80-43118f7fd769.webm`,
};
